export const ENUMERATION_AREA = 'ar';
export const ENUMERATION_BANK_LIST = 'bn';
export const ENUMERATION_BOOKSHOP_TYPE = 'sy';
export const ENUMERATION_CONTRIBUTOR_TYPE = 'ct';
export const ENUMERATION_DERIVATIVE_TYPE = 'de';
export const ENUMERATION_EVENT_TYPE = 'ev';
export const ENUMERATION_HONOR_TYPE = 'ho';
export const ENUMERATION_LANGUAGE = 'lg';
export const ENUMERATION_MATERIAL_TYPE = 'ma';
export const ENUMERATION_OBJECT_STATUS = 'ot';
export const ENUMERATION_PAGE_TYPE = 'pt';
export const ENUMERATION_PREMISES = 'pm';
export const ENUMERATION_PRICE_QUALIFIER = 'pq';
export const ENUMERATION_PRODUCT_FORM_DETAIL = 'fd';
export const ENUMERATION_SHARE_TYPE = 'sh';
export const ENUMERATION_TEXT_FORMAT = 'tf';
export const ENUMERATION_TITLE_TYPE = 'tt';

export const LOCALITY_TYPE_REGION = "O";	// О (області/АРК)
export const LOCALITY_TYPE_MEGA = "K";		// К (міста зі спецстатусом)
export const LOCALITY_TYPE_DISTRICT = "P";	// Р (райони)
export const LOCALITY_TYPE_COMMUNITY = "H";	// Н (громади)
export const LOCALITY_TYPE_CITY = "M";		// М (міста)
export const LOCALITY_TYPE_TOWN = "T";		// Т (смт)
export const LOCALITY_TYPE_VILLAGE = "C";	// С (села)
export const LOCALITY_TYPE_VILLAGE_SMALL = "X";	// X (хутір)
export const LOCALITY_TYPE_DIVISION = "B";	// В (райони в містах)


export const STRING_FORMAT_INTEGER = "int";
export const STRING_FORMAT_DECIMAL = "dec";
export const STRING_FORMAT_FORBIDDEN_VALUES = "fbdval";
export const STRING_FORMAT_ISBN = "isbn";

export const FILE_WAS_SET = "wasSet";
export const FILE_WAS_CLEARED = "wasCleared";

export const TEMPLATE_MODE_SELECTED_ONLY = "selectedOnly";
export const TEMPLATE_MODE_MARKED_ONLY = "markedOnly";
export const TEMPLATE_MODE_SELECTED_AND_MARKED = "selectedAndMarked";

export const PATCH_RESOLVE_BRAND_PROVIDER_REFS = "resolveBrandProviderRefs";
export const PATCH_NORMALIZE_ORG_CODE_AND_GID = "normalizeOrgCodeAndGid";
export const PATCH_CLEAR_ORG_DUBLETS = "clearOrgDublets";
export const PATCH_MAKE_LINK_FROM_PROVIDER_TO_BRAND = "makeLinkFromProviderToBrand";
export const PATCH_CHANGE_OFFER_PRICE_QUALIFIER = "changeOfferPriceQualifier";
export const PATCH_SET_OFFER_STOP_DATE = "setOfferStopDate";
export const PATCH_CLEAR_EBOOK_PAYMENT_DOUBLING = "clearEBookPaymentDoubling";
export const PATCH_UPDATE_BOOK_YEAR = "updateBookYear";
export const PATCH_BOOK_CLEAR_EMPTY_BRAND = "bookClearEmptyBrand";
export const PATCH_BOOK_FIX_BR = "bookFixBR";
export const PATCH_REMOVE_BREAKED_IMAGES = "removeBreakedImages";
export const PATCH_STATUS_MERCHANT_TERMINAL = "statusMerchantTerminal";
export const PATCH_SET_TERMINAL_PROVIDER = "setTerminalProvider";
export const PATCH_UPDATE_EMPTY_OWNERS = "updateNullOwners";
